<template>
  <div class="px-2 lg:px-0 md:pt-6 pb-20">
    <div
      v-if="!VPSAccounts.length && VPSAccountsLoaded"
      class="bg-white px-5 md:px-0 rounded-lg shadow-ts1 h-[91vh] maxMd:h-auto"
    >
      <div class="h-full flex justify-start md:justify-center gap-4 items-center flex-col relative py-16 md:py-0">
        <img
          src="../../assets/img/vps.svg"
          class="h-28 w-28"
        />
        <h1 class="font-display text-[2.5rem] text-blue font-bold leading-none mb-5 text-center flex items-center gap-x-2">
          <div>
            <span class="text-green">{{ $t('vps') }}</span> {{ $t('hosting') }}
          </div>
          <div class="relative group">
            <img
              class="w-[13px] h-[13px]"
              src="../../assets/img/icons/upload/info.svg"
              alt="Additional info"
            />
            <div class="font-body text-base text-gray-900 text-left font-normal absolute t-6 bg-white rounded-lg shadow-ts3 w-72 p-4 object-right-bottom hidden group-hover:block">
              {{ $t('vps_description').tTitle() }}
            </div>
          </div>
        </h1>
        <p class="text-gray-900 text-base leading-7 max-w-md text-center">{{ $t('vps_text') }}</p>
        <div class="w-full flex flex-col items-center select-none">
          <Button mode="secondary" @click="showModal()" :disabled="!TALoaded || !availableTA.length" :loading="!TALoaded" customClasses="!w-40 disabled:!bg-gray-300 !px-0 !py-3">
            {{ $t('order_now') }}
          </Button>
          <p
            class="text-orange mt-4 text-center w-full"
            v-if="!isLive"
            @click="redirectToCreateLive()"
            v-html="$t('no_available_live_account')"
          ></p>
          <p
            class="text-orange mt-4 text-center w-full"
            v-else-if="TALoaded && !availableTA.length"
            @click="showCreateAccountModal()"
            v-html="$t('no_available_trading_account')"
          ></p>
        </div>
        <div class="w-full text-center bottom-6">
          <a
            :href="VPSLink"
            target="_blank"
            class="text-gray-900 text-sm font-semibold"
          >{{ $t('learn_more') }}</a>
        </div>
      </div>
    </div>

    <div
      v-if="VPSAccounts.length > 0"
      class=""
    >
      <div class="flex gap-6  flex-col-reverse lg:flex-row">
        <div class="w-[99%] mx-2 lg:w-calc4 pt-5 bg-white rounded-lg shadow-ts1 minMaxTablet:!w-full minMaxTablet:!mx-0">
          <div class="w-full pb-4 border-b border-gray-400 border-solid">
            <h2 class="ltr:pl-5 rtl:pr-5 ltr:md:pl-8 rtl:md:pr-8 text-blue font-display font-bold text-xl leading-none">{{ $t('vps') }}</h2>
          </div>

          <div class="w-auto mt-10 pb-5 mx-5 lg:mx-0">
            <div
              class="flex w-full flex-wrap lg:px-5 pb-3.5 md:pb-0 gap-5 minMaxTablet:grid minMaxTablet:grid-cols-[repeat(auto-fill,minmax(280px,1fr))] minMaxTablet:gap-5"
              id="VpsAccountsContainer"
            >
              <div
                v-for="item in VPSAccounts"
                :key="item.trading_account"
                :id="item.trading_account"
                class="w-full md:w-[310px] flex-shrink-0 rounded-lg border border-solid border-gray-300 minMaxTablet:!w-full"
              >
                <div class="p-5 relative">
                  <div class="flex mb-5 items-center">
                    <div
                      :class="[item.product_name == 'standard' ? 'bg-gray-900 text-green' : item.product_name == 'gold' ? 'bg-[#FFBE3B] text-white' : 'bg-blue text-white']"
                      class="h-[70px] w-[70px] rounded-full text-center font-display font-bold text-[2.5rem] shrink-0 pt-2"
                    >
                      {{ item.product_name == 'standard' ? 'S' : item.product_name == 'gold' ? 'G' : 'P' }}
                    </div>
                    <div class="grow flex justify-between items-center">
                      <p class="text-blue font-semibold text-xl ltr:ml-4 rtl:mr-4">
                        {{ item.product_name == 'standard' ? 'Silver' : item.product_name == 'gold' ? 'Gold' : 'Platinum' }}
                      </p>
                      <div
                        :class="[item.status == 'requested' ? 'bg-[#FFBE3B]' : [item.status === 'active' ? 'bg-green' : 'bg-orange']]"
                        class="w-[4.7rem] h-5 text-white text-center font-semibold text-xs rounded-xl leading-4 pt-0.5"
                      >
                        {{ item.status == 'requested' ? 'Pending' : item.status.tTitle() }}
                      </div>
                    </div>
                  </div>
                  <div class="w-full rounded-lg bg-[#F0F0F4] p-4">
                    <div class="mb-4">
                      <p class="text-gray-900 text-sm leading-6 font-semibold">{{ $t('trading_account').tTitle() }}</p>
                      <p class="pt-0.5 text-blue font-bold text-4xl">{{ item.trading_account }}</p>
                    </div>
                    <div class="flex justify-between items-end">
                      <div>
                        <p class="text-gray-900 font-semibold text-xs leading-1">
                          {{ item.platform == 'mt4' ? 'MetaTrader 4' : item.platform == 'mt5' ? 'MetaTrader 5' : item.platform == 'trl' ? 'Tradelocker' : 'PAMM' }}
                        </p>
                        <p class="text-gray-900 font-semibold text-xs leading-1">
                          {{ item.type.tTitle() }}
                        </p>
                      </div>
                      <div v-if="item.next_renewal">
                        <p class="text-gray-900 font-light text-xs leading-1">{{ $t('renewal_on') }}</p>
                        <p class="pt-0.5 text-gray-900 font-semibold text-xs text-right">{{ item.next_renewal ? $formatDate(new Date(item.next_renewal)) : '' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Button
              v-if="isMobile && VPSAccounts.length < VPSAccountsCount"
              @click="showMoreItems()"
              :disabled="VPSAccountsLoading"
              id="loadMoreButton"
              mode="white"
              customClasses="table md:hidden m-auto mt-10 mb-8 !font-semibold"
            >
              {{ $t('load_more') }}
            </Button>
          </div>
        </div>

        <div class="w-full lg:w-[340px] bg-green rounded-lg shadow-ts1 flex items-center relative shrink-0 mt-7 md:mt-0 md:mr-2 minMaxTablet:!mr-0">
          <div class="w-full md:w-auto px-5 lg:px-10 py-5 lg:py-0">
            <p class="text-white lg:text-center font-display font-bold text-xl lg:text-[2.5rem] lg:leading-[1.2] mb-10 md:mb-5">{{ $t('vps_hosting_service') }}</p>
            <p class="text-white text-base leading-7 text-left lg:text-center mb-10 hidden md:block">{{ $t('vps_text') }}</p>
            <div class="flex justify-between w-full items-center">
              <div class="w-full flex flex-col items-center select-none">
                <Button mode="secondary-white" @click="showModal()" :disabled="!TALoaded || !availableTA.length" :loading="!TALoaded" customClasses="!w-48 disabled:!bg-[#8FD9C0] !px-0 lg:!m-aut">
                  {{ $t('order_now') }}
                </Button>
                <p
                  class="text-gray-900 text-sm font-bold mt-3 text-center w-full"
                  v-if="!isLive"
                  @click="redirectToCreateLive()"
                  v-html="$t('no_available_live_account')"
                ></p>
                <p
                  class="text-gray-900 text-sm font-bold mt-3 text-center w-full"
                  v-else-if="TALoaded && !availableTA.length"
                  @click="showCreateAccountModal()"
                  v-html="$t('no_available_trading_account')"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VPSModal
      @close="closeModal"
      @complete="refreshVPS"
      v-show="showVPSModal"
      :available-trading-accounts="availableTA"
    ></VPSModal>
    <create-account-modal
      @close="closeCreateAccountModal"
      @complete="refreshVPS"
      v-show="showCAModal"
    ></create-account-modal>
  </div>
</template>

<script>
import api from '@/api'
import { service } from '@/main.js'
import { mapActions, mapGetters } from 'vuex'
import links from '@/config/links'
import VPSModal from '@/components/VPSModal.vue'
import CreateAccountModal from '@/components/CreateAccountModal.vue'
import Button from '@/components/reusableComponents/Button.vue'

export default {
  components: {
    VPSModal,
    CreateAccountModal,
    Button
  },
  data() {
    return {
      isMobile: window.innerWidth < 768,
      VPSAccounts: [],
      VPSAccountsCount: 0,
      VPSAccountsPage: 0,
      VPSAccountsLoading: false,
      VPSRequestId: 0,
      VPSAccountsLoaded: false,
      TALoaded: false,
      showVPSModal: false,
      showCAModal: false,
      availableTA: [],
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
      logoLoaderActive: 'logoLoader/active',
      isLive: 'user/isLive',
    }),
    VPSLink() {
      return links.getLink('vpsToolsHosting', 'en')
    },
  },

  mounted() {
    this.refreshVPS()
    window.addEventListener('resize', this.updateVPSViewport)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateVPSViewport)
  },
  methods: {
    updateVPSViewport() {
      const isMobile = window.innerWidth < 768
      if (isMobile === this.isMobile) return
      this.isMobile = isMobile
      this.loadVPSPage(1)
    },
    closeModal() {
      this.showVPSModal = false
      document.getElementById('VPScontainer').classList.add('translate-x-full')
      document.querySelector('body').classList.remove('overflow-hidden')
    },
    showModal() {
      this.showVPSModal = true
      document.querySelector('body').classList.add('overflow-hidden')
      setTimeout(() => document.getElementById('VPScontainer').classList.remove('translate-x-full'), 10)
    },
    closeCreateAccountModal() {
      this.showCAModal = false
      document.querySelector('body').classList.remove('overflow-hidden')
      document.getElementById('CAcontainer').classList.add('translate-x-full')
    },
    showCreateAccountModal() {
      this.showCAModal = true
      document.querySelector('body').classList.add('overflow-hidden')
      setTimeout(() => document.getElementById('CAcontainer').classList.remove('translate-x-full'), 10)
    },
    async refreshVPS() {
      this.VPSAccountsLoaded = false
      this.TALoaded = false
      if (!(await this.loadVPSPage(1))) return

      const getTA = await api.GetTradingAccounts()
      if (getTA?.status !== 200) {
        this.$toasted.error(this.$t('error_request_failed'))
        this.TALoaded = true
        return false
      }

      this.TALoaded = true

      this.availableTA = []
      for (let i = 0; i < this.User.TA.length; i++) {
        if (
          this.User.TA[i].type !== 'live' ||
          this.User.TA[i].account_type_identifier === 'pamm-investor' ||
          this.User.TA[i].account_type_identifier === 'no-deposit-bonus' ||
          this.User.TA[i].account_type_identifier === 'no-deposit' ||
          this.User.TA[i].account_type_identifier === ''
        ) {
          continue
        }
        let taHasVPS = false
        for (let j = 0; j < this.VPSAccounts.length; j++) {
          if (this.User.TA[i].external_id === this.VPSAccounts[j].trading_account) {
            taHasVPS = true
            break
          }
        }
        if (!taHasVPS) {
          if (this.User.TA[i].platform === 'trl') {
            // check if the string has ('-')
            const hasDash = this.User.TA[i].account_type.includes('-')
            if (hasDash) {
              // Extract the leverage and account_type and split them
              const spiltString = this.User.TA[i].account_type.split('-')
              const leverage = parseInt(this.User.TA[i].account_type.split('-').pop())
              const accountType = spiltString[0]

              // Dynamically update the leverage and modify the account_type
              this.User.TA[i].leverage = leverage
              this.User.TA[i].account_type = accountType
            }
          }
          // remove trading competition accounts
          if (this.User.TA[i].account_type_identifier !== 'trading-competition') {
            this.availableTA.push(this.User.TA[i])
          }
        }
      }
      this.$bus.$emit('InnerRouteChange')
    },
    async loadVPSPage(page) {
      const requestId = ++this.VPSRequestId
      this.VPSAccountsLoading = true
      try {
        const getVPS = await service.post(
          'vps/list',
          {
            userID: this.User.info.ID.toString(),
            page,
            limit: this.isMobile ? 10 : 1000,
          },
          'getVPSList'
        )
        if (requestId !== this.VPSRequestId) return false
        const list = getVPS?.data?.list ?? []
        if (getVPS?.status !== 200 || !Array.isArray(list)) {
          throw new Error('Invalid VPS list response')
        }
        this.VPSAccounts = page === 1 ? list : this.VPSAccounts.concat(list)
        this.VPSAccountsCount = Number(getVPS.data?.cnt) || 0
        this.VPSAccountsPage = page
        this.VPSAccountsLoaded = true
        return true
      } catch (error) {
        if (requestId === this.VPSRequestId) {
          this.$toasted.error(this.$t('error_getting_VPS'))
        }
        return false
      } finally {
        if (requestId === this.VPSRequestId) this.VPSAccountsLoading = false
      }
    },
    async showMoreItems() {
      if (!this.isMobile || this.VPSAccountsLoading || this.VPSAccounts.length >= this.VPSAccountsCount) return
      await this.loadVPSPage(this.VPSAccountsPage + 1)
    },
    redirectToCreateLive() {
      this.$router.push('/' + this.Language + '/register/upgrade')
    },
    ...mapActions(['logoLoader/set', 'errorModal/set']),
  },
}
</script>
